import { Command } from '@/plugins/cad/module/core/Command'
import { EntityEditHandler, type RotateParams } from '../edit/EntityEditHandler'
import type { CADViewManager } from '../manager/CADViewManager'
import type { IEntity } from '../model/entity'

/**
 * 旋转实体命令，绕指定中心旋转实体并支持撤销。
 */
export class RotateEntityCommand extends Command {
  private entities: IEntity[]
  private params: RotateParams
  private viewManager: CADViewManager

  constructor(entities: IEntity[], params: RotateParams, viewManager: CADViewManager) {
    super()
    this.entities = entities
    this.params = params
    this.viewManager = viewManager
  }

  /** 对所有实体按给定中心与角度执行旋转 */
  execute(): void {
    EntityEditHandler.rotate(this.entities, this.params)
    this.viewManager.updateEntities(this.entities, { updateGeometry: true })
  }

  /** 撤销：按反向角度还原实体原姿态 */
  undo(): void {
    EntityEditHandler.rotate(this.entities, {
      center: this.params.center,
      angle: -this.params.angle,
    })
    this.viewManager.updateEntities(this.entities, { updateGeometry: true })
  }
}
